import { Box, Grid, Typography } from 'src/components/mui';
//@ts-ignore
import React from 'react';
import { useMemo } from 'react';
import { getItems } from './config';
import { getLucideIconByName } from '@packages/ui-components';
import { Icon } from '@mui/material';

type Props = {
  translation?: any;
};

export default function MoreHelp({ translation }: Props) {
  const items = useMemo(() => getItems(translation), [translation]);

  return (
    <Grid container spacing={4} justifyContent="center" columns={10} rowSpacing={16}>
      {items.map((i, index) => {
        const getIcon = (icon: string) => {
          if (icon === 'mp-dollhouse' || icon === 'mp-floorplan') {
            return <Icon className={icon} sx={{ fontSize: '45px !important', margin: '20px 0', display: 'inline-flex', alignItems: 'center' }} />;
          }
          if (icon.startsWith('https')) {
            return <Box component="img" src={icon} alt="" sx={{ width: 75, height: 45, objectFit: 'contain', margin: '20px 0' }} />
          }
          const LucideIcon = getLucideIconByName(icon);
          return <LucideIcon size={45} style={{ margin: '20px 0' }} />;
        };
        return (
          <Grid key={index} size={2} textAlign="center">
            <Typography sx={{ fontWeight: 500, fontSize: '1.45vw' }}>{i.title}</Typography>
            {getIcon(i.icon)}
            <Typography>{i.description}</Typography>
          </Grid>
        );
      })}
    </Grid>
  );
}
